import React from 'react';

const OPTIONS = [
  { value: 7, label: '7d' },
  { value: 30, label: '30d' },
  { value: 90, label: '90d' },
];

export default function RangeSelect({ value, onChange, disabled }) {
  return (
    <div className="inline-flex items-center p-0.5 rounded-full border border-white/[0.06] bg-white/[0.02]">
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1 rounded-full text-[12px] font-medium tracking-wide transition-all ${
              active
                ? 'bg-[#B0FC38]/[0.15] text-white shadow-sm'
                : 'text-gray-500 hover:text-white'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
